import { useEffect } from "react";
import { useFeatureFlags } from "../hooks/useFeatureFlags";

/**
 * Component to initialize feature flags on app load
 * Place this at the root level of your app to ensure flags are loaded early
 */
export function FeatureFlagsInitializer() {
	const { flagsLoaded } = useFeatureFlags();

	useEffect(() => {
		if (flagsLoaded) {
			console.log("[FeatureFlags] Feature flags loaded successfully");
		}
	}, [flagsLoaded]);

	// This component doesn't render anything, it just initializes the flags
	return null;
}
